<template>
  <div class="index-hot-sol-box">
    <div class="hot-sol-title">
      <span class="hot-sol-left">热门方案推荐</span>
      <span @click="goMore" class="hot-sol-right">查看更多</span>
    </div>
      <swiper :options="swiperOption" class="hot-swiper-box" v-if="swiperList && swiperList.length">
        <swiper-slide  v-for="(banner, index) in swiperList" :key="index">
          <ul class="public-list">
            <!-- type=sol 方案列表 -->
            <li class="sol-list-item" v-for="(item, _index) in banner" :key="_index">
              <!-- 方案热搜列表 -->
              <div class="hot-search" @click="jumpDetail(item)">
                <div class="hot-search-left">
                  <img :src="item.matchPic | getImageUrl" />
                </div>
                <div class="hot-search-right">
                  <div class="item-title">
                    {{ item.solutionName }}
                  </div>
                  <div class="item-count">
                    <span>{{ item.userName }}</span>
                    <span>{{
                      item.shelveTime && item.shelveTime.split(" ")[0]
                    }}</span>
                    <div><span class='span'>{{item.pageView | myriabit}}</span> <span class='span1'>阅读量</span></div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </swiper-slide >
      </swiper>
       <div class="swiper-pagination swiper-pagination-hot"></div>
  </div>
</template>

<script>
import { textSlice, myriabit, getImageUrl } from '@/filters/commonFilters'
import { mapState } from 'vuex'
export default {
  name: 'index-hot-list',
  filters: {
    textSlice,
    myriabit,
    getImageUrl
  },
  computed: {
    ...mapState({
      hotSolutions: state => state.home.hotSolutions
    })
  },
  watch: {
    hotSolutions (newV, oldV) {
      this.list = newV
      this.swiperList = this.madeSwiper(newV)
    }
  },
  data () {
    return {
      list: [],
      swiperList: [],
      swiperOption: {
        loop: true,
        pagination: {
          el: '.swiper-pagination-hot',
          type: 'bullets'
        },
        observer: true,
        observeParents: true
      }
    }
  },
  created () {
  },
  mounted () {
    this.getData()
  },
  methods: {
    goMore () {
      this.$router.push('/solutions/list.html')
    },
    madeSwiper (oldList = []) {
      let len = oldList.length % 4 ? parseInt(oldList.length / 4) + 1 : parseInt(oldList.length / 4)
      let swiperList = []
      for (let i = 0; i < len; i++) {
        let start = i * 4
        let end = ((i + 1) * 4)
        swiperList.push(oldList.slice(start, end))
      }
      return swiperList
    },
    // 方案详情
    jumpDetail (item) {
      this.$router.push(`/solutions/detail/${item.solutionId}.html`)
    },
    getData () {
      if (!this.hotSolutions || this.hotSolutions.length === 0) {
        this.$store.dispatch('HOME_HOT_SEARCH_SOLUTIONS')
      } 
    }
  }
}
</script>

<style lang="scss">
@mixin TwoLine {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.index-hot-sol-box {
  width: 343px;
  background: #fff;
  margin: 0 auto;
  border-radius: 8px;
  overflow: hidden;
  position: relative;

  .van-swipe__track {
    height: 428px!important;
  }
  .van-swipe__indicators {
      bottom: 12px;
  }
  .van-swipe__indicator {
      width: 4px;
      height: 4px;
      opacity: 1;
      background: rgba(29,111,233,0.30);
      border-radius: 2px;
  }
  .van-swipe__indicator--active {
      width: 12px;
      height: 4px;
      opacity: 1;
      background: #1d6fe9;
      border-radius: 2px;
  }

  .hot-sol-title {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 26px 0 15px;
    .hot-sol-left {
      color: #000000;
      font-size: 15px;
      font-weight: bold;
    }
    .hot-sol-right {
      font-size: 12px;
      color: #a0a0a0;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        display: block;
        right: -11px;
        width: 0;
        height: 0;
        overflow: hidden;
        line-height: 0;
        font-size: 0;
        vertical-align: middle;
        border-left: 6px solid rgba(0, 0, 0, 0.12);
        border-right: 0 none;
        border-top: 4px solid transparent;
        border-bottom: 4px solid transparent;
      }
    }
  }
  .public-list {
    background-color: #fff;
    .sol-list-item {
      padding: 12px 0;
      margin: 0 16px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      .hot-search {
        display: flex;
        justify-content: space-between;
        &-left {
          width: 110px;
          height: 75px;
          flex: 0 0 auto;
          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
            border-radius: 4px;
          }
        }
        &-right {
          width: 193px;
          flex: 0 0 auto;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .item-title {
            font-size: 15px;
            color: rgba(0,0,0,0.65);
            white-space: normal;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            line-height: 23px;
            word-wrap:break-word;
            font-weight: bold;
          }
          .item-count {
            margin-top: 5px;
            color: #a0a0a0;
            font-size: 10px;
            display: flex;
            justify-content: space-between;
            color: rgba(0,0,0,0.45);
            font-size: 12px;
            line-height: 15px;
            span {
              margin-right: 8px;
              &:last-child {
                  margin-right: 0;
              }
            }
            div{
              width: 80px;
              float: right;
              text-align: right;
            .span1{
              font-size: 10px;
              color: #a0a0a0;
            }
            .span{
              margin-right: 0px;
              font-size: 10px;
              color: #f8a325;
            }
            }
          }
        }
      }
      &:last-child {
        border-bottom: 0;
      }
    }
  }

  .hot-swiper-box {
      height: 428px;
  }

   .swiper-pagination {
      bottom: 12px;
      left: 0;
      right: 0;
      margin: auto;
    }
    .swiper-wrapper {
      backface-visibility: hidden;
      -webkit-transform-style: preserve-3d;
      transform-style: preserve-3d;
      -webkit-overflow-scrolling: touch;
    }
    .swiper-pagination-bullet {
      width: 4px;
      height: 4px;
      opacity: 1;
      background: rgba(29,111,233,0.30);
      border-radius: 2px;
      margin: 0 2px;
    }
    .swiper-pagination-bullet-active {
       width: 12px;
      height: 4px;
      opacity: 1;
      background: #1d6fe9;
      border-radius: 2px;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/indexTemplate/indexHotList.vue